import one from "../../assets/partners/one.jpg";
import two from "../../assets/partners/two.jpg";
import three from "../../assets/partners/three.jpg";
import four from "../../assets/partners/four.jpg";
import five from "../../assets/partners/five.jpg";
import six from "../../assets/partners/six.jpg";
import seven from "../../assets/partners/seven.jpg";
import eight from "../../assets/partners/eight.webp";
import nine from "../../assets/partners/nine.jpg";
import ten from "../../assets/partners/ten.jpg";

export const PartnerImageList = [
  { id: 1, name: one },
  { id: 2, name: two },
  { id: 3, name: three },
  { id: 4, name: four },
  { id: 5, name: five },
  { id: 6, name: six },
  { id: 7, name: seven },
  { id: 8, name: eight },
  { id: 9, name: nine },
  { id: 10, name: ten },
];
